import { ExplainerLayout } from '@/components/ExplainerLayout';
import { KSIEGOWOSC_ONLINE } from '@/content/przewodniki';

const KsiegowoscOnline = () => <ExplainerLayout guide={KSIEGOWOSC_ONLINE} />;

export default KsiegowoscOnline;
